import { AlertModal } from '@app/components/AlertModal';
import { useAppSelector } from '@app/hooks';
import { selectErrorModal } from '@app/slices/modals';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, Col, Drawer, Button, Icon } from '@common/components';
import { MainFilters } from '@dashboard/components';
import { useTranslation } from 'react-i18next';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import layoutClasses from './LayoutFilters.module.scss';

export default function LayoutFilters(props) {
  const { children } = props;
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation('dashboard\\LayoutFilters');

  const error = useAppSelector(selectErrorModal);

  return (
    <div className={layoutClasses.Layout}>
      <Grid>
        <Col className={layoutClasses.mainFilters} xss={12} xs={12} md={3}>
          <MainFilters />
        </Col>
        <Col xss={12} xs={12} md={9}>
          <Button
            className={layoutClasses.grayButton}
            fullWidth
            variant="flat"
            color="accent"
            onClick={() => setIsOpen(!isOpen)}
            prefix={<Icon color="grey-300" icon={faFilter} />}
          >
            {t('filtersLabel')}
          </Button>
          <section className={layoutClasses.main}>{children}</section>
        </Col>
      </Grid>

      <Drawer
        id="drawer-filters"
        position="right"
        isOpen={isOpen}
        className={layoutClasses.drawer}
        onClose={() => setIsOpen(!isOpen)}
      >
        <MainFilters />
      </Drawer>

      <AlertModal
        show={error && error.data && error.data.message !== undefined}
        type="error"
        title="genericErrorTitle"
        text={
          error &&
          error.data &&
          error.data.message &&
          (!error.status || error.status < 500)
            ? error.data.message
            : 'genericError'
        }
      />
    </div>
  );
}

LayoutFilters.propTypes = {
  children: PropTypes.node,
};
